import { render } from "./FavoriteSpotCard.vue?vue&type=template&id=54df93c7"
import script from "./FavoriteSpotCard.vue?vue&type=script&lang=js"
export * from "./FavoriteSpotCard.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__